/**
 * Asks whether the signed-in operator holds a permission.
 *
 * Reads the session the auth gate already fetched rather than making a call of
 * its own: the permissions arrive with the session probe on load, so this is a
 * set lookup and not a query. Mirrors famtrak's useHasPermission, which needs
 * queries only because its permissions are group-scoped and this one's are not.
 */
import { useMemo } from 'react';

import { useSession } from '../../components/RequireAuth';
import { hasPermission, permissionSet, type Permission } from './permissions';

/** Whether the operator holds any of the given permissions. */
export function usePermission(permission: Permission | readonly Permission[]): boolean {
  const { session } = useSession();

  const held = useMemo(() => permissionSet(session.permissions), [session.permissions]);

  return hasPermission(held, permission);
}
